import { render, staticRenderFns } from "./m_page.vue?vue&type=template&id=e7caf2d8&scoped=true"
import script from "./m_page.vue?vue&type=script&lang=js"
export * from "./m_page.vue?vue&type=script&lang=js"
import style0 from "./m_page.vue?vue&type=style&index=0&id=e7caf2d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7caf2d8",
  null
  
)

export default component.exports